import Form from '@/found/components/form';
import request from '@/found/utils/request';
import { RISK_RULE_ENDPOINTS } from '../actions';

export const ALARM_NUM_MIN = 1;
export const ALARM_NUM_MAX = 9999;
export const ALARM_NUM_MESSAGE = '单人绑定用户预警数量必须是1到9999之间的正整数';

export function isValidAlarmNum(value) {
  if (value === null || value === undefined || value === '' || typeof value === 'boolean') {
    return false;
  }
  const number = typeof value === 'number' ? value : Number(value);
  return Number.isInteger(number) && number >= ALARM_NUM_MIN && number <= ALARM_NUM_MAX;
}

export function validateAlarmNum(rule, value, callback) {
  if (isValidAlarmNum(value)) {
    callback();
    return;
  }
  callback(new Error(ALARM_NUM_MESSAGE));
}

export default {
  extends: Form,
  data() {
    const formConfig = this.formConfig || {};
    return {
      formFunctionCode: formConfig.formFunctionCode
        || (this.$route && this.$route.query && this.$route.query.formFunctionCode)
        || 'risk_rule_form',
      buttonText: {
        submit: '保存并启用',
        close: '取消',
        submitAudit: '保存并启用',
      },
    };
  },
  methods: {
    setRule(item) {
      if (item.field !== 'alarmNum') return item;

      const rule = item;
      rule.props = {
        ...rule.props,
        min: ALARM_NUM_MIN,
        max: ALARM_NUM_MAX,
        precision: 0,
        step: 1,
        controls: false,
      };
      rule.validate = [
        ...(rule.validate || []),
        {
          trigger: 'blur',
          validator: validateAlarmNum,
          message: ALARM_NUM_MESSAGE,
        },
      ];
      if (rule.value !== undefined && rule.value !== null && rule.value !== ''
        && !isValidAlarmNum(rule.value)) {
        rule.value = '';
      }
      return rule;
    },

    formComplete() {
      if (this.formConfig && this.formConfig.row && this.formConfig.code !== 'add') {
        this.setValue(this.formConfig.row);
      }
    },

    submit(requestClient) {
      const client = requestClient && typeof requestClient.post === 'function'
        ? requestClient
        : request;
      const formData = this.getFormData();
      if (!formData) return Promise.resolve({ success: false, skipped: true });
      if (!isValidAlarmNum(formData.alarmNum)) {
        this.$message.error(ALARM_NUM_MESSAGE);
        return Promise.resolve({ success: false, skipped: true });
      }

      return client.post(RISK_RULE_ENDPOINTS.add, { ...formData }).then((res) => {
        if (res.success) {
          this.$message({ type: 'success', message: '保存并启用成功' });
          this.$emit('onClose');
          this.$emit('onGetList');
        }
        return res;
      });
    },
  },
};
